// extracted by mini-css-extract-plugin
export default {"backBtn":"back_btn_backBtn__OojJ6"};